export const numberFormatter = (num: number | string) => {
  const number = Number(num);

  if (isNaN(number)) return "N/A";
  return num !== undefined && num !== null
    ? Number(num).toLocaleString("vi-VN")
    : "N/A";
};

export const dateFormatter = (dateString: any) => {
  const date = new Date(dateString);
  if (!date.getDate()) return "";
  return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
}